import { render, staticRenderFns } from "./BaseInputFile.vue?vue&type=template&id=3f13c3c7&scoped=true&"
import script from "./BaseInputFile.vue?vue&type=script&lang=js&"
export * from "./BaseInputFile.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputFile.vue?vue&type=style&index=0&id=3f13c3c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f13c3c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f13c3c7')) {
      api.createRecord('3f13c3c7', component.options)
    } else {
      api.reload('3f13c3c7', component.options)
    }
    module.hot.accept("./BaseInputFile.vue?vue&type=template&id=3f13c3c7&scoped=true&", function () {
      api.rerender('3f13c3c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Bases/Inputs/BaseInputFile.vue"
export default component.exports